import { render, staticRenderFns } from "./opinion.vue?vue&type=template&id=32dcd8c1&scoped=true&"
import script from "./opinion.vue?vue&type=script&lang=js&"
export * from "./opinion.vue?vue&type=script&lang=js&"
import style0 from "./opinion.vue?vue&type=style&index=0&id=32dcd8c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dcd8c1",
  null
  
)

export default component.exports